<template>
  <ul @click="onPagerClick" class="el-pager">
    <li :class="{ active: currentPage === 1, disabled }" v-if="pageCount > 0" class="number">1</li>
    <li class="el-icon more btn-quickprev" :class="[quickprevIconClass, { disabled }]" v-if="showPrevMore" @mouseenter="onMouseenter('left')" @mouseleave="quickprevIconClass = 'icon-more'"></li>
    <li v-for="pager in pagers" :key="pager" :class="{ active: currentPage === pager, disabled }" class="number">{{ pager }}</li>
    <li :class="{ active: currentPage === pageCount, disabled }" class="number" v-if="pageCount > 1 && (pageCount < 6 || pageCount - currentPage < 3)">{{ pageCount }}</li>
  </ul>
</template>

<script type="text/babel">
// 从element-ui的分页组件拷贝修改而成，原代码见 `./node_modules/element-ui/packages/pagination/src/pager.vue`
export default {
  name: 'EmPager',

  props: {
    disabled: Boolean
  },

  watch: {
    showPrevMore (val) {
      if (!val) this.quickprevIconClass = 'icon-more'
    },

    showNextMore (val) {
      if (!val) this.quicknextIconClass = 'icon-more'
    }
  },

  methods: {
    onPagerClick (event) {
      const target = event.target
      if (target.tagName === 'UL' || this.disabled) {
        return
      }

      let newPage = Number(event.target.textContent)
      const pageCount = this.pageCount
      const currentPage = this.currentPage
      const pagerCountOffset = this.pagerCount - 2

      if (target.className.indexOf('more') !== -1) {
        if (target.className.indexOf('quickprev') !== -1) {
          newPage = currentPage - pagerCountOffset
        } else if (target.className.indexOf('quicknext') !== -1) {
          newPage = currentPage + pagerCountOffset
        }
      }

      /* istanbul ignore if */
      if (!isNaN(newPage)) {
        if (newPage < 1) {
          newPage = 1
        }

        if (newPage > pageCount) {
          newPage = pageCount
        }
      }

      if (newPage !== currentPage) {
        this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(newPage)
        this.$parent.userChangePageSize = true
        this.$parent.emitChange()
        // this.$emit('change', newPage)
      }
    },

    onMouseenter (direction) {
      if (this.disabled) return
      if (direction === 'left') {
        this.quickprevIconClass = 'icon-double-left'
      } else {
        this.quicknextIconClass = 'icon-double-right'
      }
    },
    setPre (val) {
      this.showPrevMore = val
    }
  },

  computed: {
    currentPage () {
      return this.$parent.internalCurrentPage
    },
    pageCount () {
      return this.$parent.internalPageCount
    },
    pagerCount () {
      return 6
    },
    pagers () {
      const pagerCount = this.pagerCount
      const halfPagerCount = (pagerCount - 1) / 2

      const currentPage = Number(this.currentPage)
      const pageCount = Number(this.pageCount)

      let showPrevMore = false
      let showNextMore = false

      if (pageCount > pagerCount) {
        if (currentPage > pagerCount - halfPagerCount) {
          showPrevMore = true
        }

        if (currentPage < pageCount - halfPagerCount) {
          showNextMore = true
        }
      }

      const array = []

      if (showPrevMore && !showNextMore) {
        const startPage = pageCount - (pagerCount - 2)
        for (let i = startPage; i < pageCount; i++) {
          array.push(i)
        }
      } else if (!showPrevMore && showNextMore) {
        for (let i = 2; i < pagerCount; i++) {
          array.push(i)
        }
      } else if (showPrevMore && showNextMore) {
        const offset = Math.floor(pagerCount / 2) - 1
        for (let i = currentPage - offset; i <= currentPage + offset; i++) {
          array.push(i)
        }
      } else {
        for (let i = 2; i < pageCount; i++) {
          array.push(i)
        }
      }
      this.setPre(showPrevMore)
      return array
    }
  },

  data () {
    return {
      current: null,
      showPrevMore: false,
      showNextMore: false,
      quicknextIconClass: 'icon-more',
      quickprevIconClass: 'icon-more'
    }
  }
}
</script>
